import AdminContainer from "../../../components/admin/AdminContainer"
import React, {useEffect, useState} from "react"
import AdminTable from "../../../components/admin/AdminTable"
import {BACKEND_URL, BRAND_NAME} from "../../../data/config"
import {Button, IconButton, Grid, TextField, MenuItem, Autocomplete} from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import {Link} from "react-router-dom"
import AddIcon from "@mui/icons-material/Add"
import SearchIcon from "@mui/icons-material/Search"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import {useGlobalContext} from "../../../contexts/global_context"
import {Helmet} from "react-helmet"
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator"
import {getInputValue} from "../../../utils"
import Box from "@mui/material/Box"
import SearchContainer from "../../../components/admin/SearchContainer";

const DeleteDialog = ({deletingItemUid, setDeletingItemUid, fetchData}) => {
  let {sendAjax} = useGlobalContext()

  const DeleteItem = (uid) => {
    sendAjax({
      url: `${BACKEND_URL}/api/v1/commerce/order-discounts/${uid}/`,
      method: "delete",
      data: {},
    }).then((r) => {
      setDeletingItemUid("")
      fetchData()
    })
  }

  return (
    <Dialog
      open={Boolean(deletingItemUid)}
      onClose={() => {
        setDeletingItemUid("")
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Order Discount?"}</DialogTitle>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingItemUid("")
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            DeleteItem(deletingItemUid)
          }}
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const OrderDiscountListAdminPage = () => {
  let {sendAjax} = useGlobalContext()
  const [page, setPage] = useState(0)
  const [data, setData] = useState({})
  const [deletingItemUid, setDeletingItemUid] = useState("")
  const [categories, setCategories] = useState([])
  let items = []
  let numTotal = 0

  const filters_init_value = {
    title: '',
    code: '',
    social: '',
    category_uids: [],
    status: '',
  }

  let [filters, setFilters] = useState(filters_init_value)

  const handleChange = (event) => {
    setFilters({...filters, [event.target.name]: getInputValue(event.target)})
  }

  const handleComboBoxChange = (name) => (event, value) => {
    setFilters({...filters, [name]: value})
  }

  const handleSubmitSearch = (event) => {
    event.preventDefault()
    fetchData()
  }

  const fetchData = () => {
    const query = new URLSearchParams()

    // Add filters to query if they have values
    if (filters.title) query.append('title', filters.title)
    if (filters.code) query.append('code', filters.code)
    if (filters.social) query.append('social', filters.social)
    if (filters.status) query.append('status', filters.status)
    if (filters.category_uids.length > 0) {
      filters.category_uids.forEach(uid => query.append('category_uids', uid))
    }

    sendAjax({
      url: `${BACKEND_URL}/api/v1/commerce/order-discounts/?${query.toString()}`,
      method: "get",
      data: {page: page + 1},
    }).then((r) => {
      setData(r.data)
    })
  }

  const handleClickDelete = (uid) => {
    setDeletingItemUid(uid)
  }

  useEffect(() => {
    // Fetch categories for filter
    sendAjax({
      url: `${BACKEND_URL}/api/v1/pkg/admin/categories/`,
      method: 'get',
      data: {page_size: 1000},
    }).then((r) => {
      if (r.data.status_code === 200) {
        setCategories(r.data.data.results)
      }
    })
  }, [])

  useEffect(() => {
    fetchData()
  }, [page])

  try {
    for (let [index, item] of data.data.results.entries()) {
      console.log(item)
      items.push({
        uid: item.uid,
        "#": index + 1,
        title: item.title || '-',
        code: item.code || '-',
        discount_type: item.discount_type === 10 ? 'Fixed price' : 'Percentage',
        value: item.value,
        expire_date: item.expire_date ? new Date(item.expire_date).toLocaleDateString() : '-',
        max_usage: item.max_usage || '-',
        usage_count: item.usage_count,
        status: item.status === 10 ? 'Active' : 'Inactive',
        actions: (
          <>
            <IconButton
              component={Link}
              to={`/admin/order-discounts/update/${item.uid}`}
            >
              <EditIcon/>
            </IconButton>

            <IconButton
              onClick={() => {
                handleClickDelete(item.uid)
              }}
            >
              <DeleteIcon/>
            </IconButton>
          </>
        ),
      })
    }
    numTotal = data.data.count
  } catch {
  }

  return (
    <AdminContainer>
      <Helmet>
        <title>Order Discounts - {BRAND_NAME}</title>
      </Helmet>

      <DeleteDialog
        {...{deletingItemUid, setDeletingItemUid, fetchData}}
      />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Button
            component={Link}
            to={"/admin/order-discounts/create"}
            variant="outlined"
            startIcon={<AddIcon/>}
          >
            Add Order Discount
          </Button>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <SearchContainer>
            <Box
              component={ValidatorForm}
              onSubmit={handleSubmitSearch}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <TextValidator
                    label="Title"
                    placeholder="Search by title..."
                    name="title"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    value={filters.title}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextValidator
                    label="Discount Code"
                    placeholder="Search by code..."
                    name="code"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    value={filters.code}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextValidator
                    select
                    label="Social Platform"
                    name="social"
                    variant="outlined"
                    fullWidth
                    value={filters.social}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    <MenuItem value="">All Platforms</MenuItem>
                    <MenuItem value={10}>Instagram</MenuItem>
                    <MenuItem value={20}>TikTok</MenuItem>
                    <MenuItem value={30}>Clubhouse</MenuItem>
                  </TextValidator>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextValidator
                    select
                    label="Status"
                    name="status"
                    variant="outlined"
                    fullWidth
                    value={filters.status}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    <MenuItem value="">All Status</MenuItem>
                    <MenuItem value={10}>Active</MenuItem>
                    <MenuItem value={20}>Inactive</MenuItem>
                  </TextValidator>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    disablePortal
                    name="category_uids"
                    options={categories.map(category => category.uid)}
                    onChange={handleComboBoxChange('category_uids')}
                    value={filters.category_uids}
                    getOptionLabel={(option) => {
                      let category = categories.find((item) => item.uid === option)
                      return category ? category.title : ''
                    }}
                    renderInput={(params) => (
                      <TextValidator
                        {...params}
                        name="category_uids"
                        label="Categories"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    startIcon={<SearchIcon/>}
                    sx={{marginRight: 2}}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      filters = filters_init_value
                      setFilters(filters_init_value)
                      fetchData()
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </SearchContainer>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <AdminTable
            items={items}
            numTotal={numTotal}
            page={page}
            setPage={setPage}
          />
        </Grid>

      </Grid>
    </AdminContainer>
  )
}

export default OrderDiscountListAdminPage